import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseCacheService } from 'src/app/core/base/base-cache.service';
import { ConfigService } from 'src/app/shared/services/utils/config.service';
import { ApiResponse } from 'src/app/shared/models/api.response';
import { DelegationWorkflow } from 'src/app/shared/models/delegation-workflow.model';
import { eDelegationWorkflowFeature } from '../enum/delegation-workflow-feature.enum';

@Injectable({ providedIn: 'root' })
export class DelegationWorkflowApiService extends BaseCacheService<DelegationWorkflow> {
  public constructor(http: HttpClient, configService: ConfigService) {
    super(eDelegationWorkflowFeature.apiPath, http, configService);
  }

  public getDelegationById(id: string | number): Observable<ApiResponse<DelegationWorkflow>> {
    return this.get<ApiResponse<DelegationWorkflow>>(`${eDelegationWorkflowFeature.apiPath}/${id}`);
  }

  public getDelegation(companyId: number): Observable<ApiResponse<DelegationWorkflow[]>> {
    return this.get<ApiResponse<DelegationWorkflow[]>>(eDelegationWorkflowFeature.enableDisablePath, { companyId });
  }

  public enableDisableDelegation(data: Record<string, unknown>): Observable<ApiResponse<unknown>> {
    return this.post<ApiResponse<unknown>>(eDelegationWorkflowFeature.enableDisablePath, data);
  }

  public deleteDelegation(id: string | number): Observable<ApiResponse<unknown>> {
    return this.delete<ApiResponse<unknown>>(`${eDelegationWorkflowFeature.apiPath}?workflowId=${id}`);
  }

  public updateDelegation(data: Record<string, unknown>): Observable<ApiResponse<unknown>> {
    return this.put<ApiResponse<unknown>>(eDelegationWorkflowFeature.apiPath, data);
  }
}
